// Only a concrete, local assessment route may survive profile setup/login.
export function assessmentReturn(value) {
  if (typeof value !== 'string' || value.length > 2000 || value.includes('\\')
      || [...value].some((character) => character.charCodeAt(0) <= 32)) return null;
  if (!/^\/assessment\/[1-9]\d*(?:[?#]|$)/.test(value)) return null;
  const url = new URL(value, 'https://ail.invalid');
  return url.origin === 'https://ail.invalid' && /^\/assessment\/[1-9]\d*$/.test(url.pathname)
    ? value : null;
}
